export const setSocketServerAddress = () => {
  const { host } = window.location;

  if (
    host.match(/localhost/g) ||
    host.includes("192.") ||
    host.includes("dev.")
  ) {
    return import.meta.env.VITE_APP_SOCKET_HOST;
  }
  if (host.match(/stage/g)) {
    return "wss://ws.stage.glorycoin.co";
  }
  if (
    host.match(/\b(dev)\b/g) ||
    (!host.startsWith("dev") && !host.startsWith("192."))
  ) {
    return `wss://ws.${host}/`;
  }
  return `wss://ws.${host}/`;
};
